import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';

const CurrentSystemsForm = ({ formData, updateFormData, errors }) => {
  const currentSoftwareOptions = [
    { value: 'excel', label: 'Hojas de Cálculo (Excel/Sheets)' },
    { value: 'erp_legacy', label: 'ERP Tradicional (SAP/Oracle)' },
    { value: 'crm', label: 'CRM (Salesforce/Hubspot)' },
    { value: 'basic_automation', label: 'Automatización Básica (Zapier)' },
    { value: 'ai_tools', label: 'Herramientas IA (ChatGPT)' },
    { value: 'custom', label: 'Sistemas a Medida' },
    { value: 'paper', label: 'Documentos Físicos / Papel' },
    { value: 'none', label: 'Procesos 100% Manuales' }
  ];

  const automationLevelOptions = [
    { value: 'none', label: 'Totalmente Manual' },
    { value: 'basic', label: 'Básico (Macros simples)' },
    { value: 'moderate', label: 'Moderado (Algunas integraciones)' },
    { value: 'advanced', label: 'Avanzado (RPA/APIs)' },
    { value: 'full', label: 'Altamente Automatizado' }
  ];

  const departmentOptions = [
    { value: 'accounting', label: 'Contabilidad y Finanzas' },
    { value: 'sales', label: 'Ventas y CRM' },
    { value: 'inventory', label: 'Inventario y Almacén' },
    { value: 'hr', label: 'Recursos Humanos' },
    { value: 'production', label: 'Producción' },
    { value: 'purchasing', label: 'Compras' },
    { value: 'project', label: 'Gestión de Proyectos' },
    { value: 'quality', label: 'Control de Calidad' },
    { value: 'other', label: 'Otros' }
  ];

  const handleSoftwareChange = (value, checked) => {
    const currentSoftware = formData.currentSoftware || [];
    if (checked) {
      updateFormData('currentSoftware', [...currentSoftware, value]);
    } else {
      updateFormData('currentSoftware', currentSoftware.filter(item => item !== value));
    }
  };

  const handleDepartmentChange = (value, checked) => {
    const departments = formData.departmentsUsingSystem || [];
    if (checked) {
      updateFormData('departmentsUsingSystem', [...departments, value]);
    } else {
      updateFormData('departmentsUsingSystem', departments.filter(item => item !== value));
    }
  };

  return (
    <div className="space-y-8">
      <div>
        <h4 className="text-lg font-bold text-slate-900 mb-4">Software y Herramientas Actuales</h4>
        <CheckboxGroup
          label="¿Qué herramientas dominan sus operaciones?"
          description="Seleccione todas las que apliquen"
          error={errors.currentSoftware}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {currentSoftwareOptions.map((option) => (
              <Checkbox
                key={option.value}
                label={option.label}
                checked={(formData.currentSoftware || []).includes(option.value)}
                onChange={(e) => handleSoftwareChange(option.value, e.target.checked)}
              />
            ))}
          </div>
        </CheckboxGroup>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Nivel de Automatización Actual"
          placeholder="¿Qué tan automatizados están sus procesos?"
          options={automationLevelOptions}
          value={formData.automationLevel || ''}
          onChange={(value) => updateFormData('automationLevel', value)}
          error={errors.automationLevel}
          description="Evalúe qué tanto dependen de la intervención humana"
        />

        <Input
          label="Horas perdidas en tareas repetitivas"
          type="text"
          value={formData.wastedHours || ''}
          onChange={(e) => updateFormData('wastedHours', e.target.value)}
          error={errors.wastedHours}
          description="Estimado semanal por empleado"
        />
      </div>

      <div>
        <h4 className="text-lg font-bold text-slate-900 mb-4">Departamentos con Mayor Carga Manual</h4>
        <CheckboxGroup
          label="¿En qué áreas hay mayores cuellos de botella?"
          description="Seleccione los departamentos que necesitan mayor automatización"
          error={errors.departmentsUsingSystem}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {departmentOptions.map((option) => (
              <Checkbox
                key={option.value}
                label={option.label}
                checked={(formData.departmentsUsingSystem || []).includes(option.value)}
                onChange={(e) => handleDepartmentChange(option.value, e.target.checked)}
              />
            ))}
          </div>
        </CheckboxGroup>

        {(formData.departmentsUsingSystem || []).includes('other') && (
          <div className="pl-8 pt-4">
            <Input
              label="Por favor, especifique otros departamentos"
              type="text"
              placeholder="Ej: Marketing, Logística"
              value={formData.otherDepartments || ''}
              onChange={(e) => updateFormData('otherDepartments', e.target.value)}
            />
          </div>
        )}
      </div>

      <Input
        label="Principales Cuellos de Botella"
        type="text"
        placeholder="Describa las tareas que consumen más tiempo de su equipo"
        value={formData.systemChallenges || ''}
        onChange={(e) => updateFormData('systemChallenges', e.target.value)}
        error={errors.systemChallenges}
        description="Esta información nos ayudará a encontrar las mejores oportunidades de IA"
      />
    </div>
  );
};

export default CurrentSystemsForm;